import { render, staticRenderFns } from "./ContractorPublicPage.vue?vue&type=template&id=2ec6cdeb"
import script from "./ContractorPublicPage.vue?vue&type=script&lang=ts"
export * from "./ContractorPublicPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec6cdeb')) {
      api.createRecord('2ec6cdeb', component.options)
    } else {
      api.reload('2ec6cdeb', component.options)
    }
    module.hot.accept("./ContractorPublicPage.vue?vue&type=template&id=2ec6cdeb", function () {
      api.rerender('2ec6cdeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketplace/ContractorPublicPage.vue"
export default component.exports